module.exports = __webpack_public_path__ + "img/846-9b3634.png";